import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-accent-100 flex items-center justify-center">
          <i className="ri-error-warning-line text-accent-600 text-2xl"></i>
        </div>
        <h1 className="font-heading text-4xl md:text-5xl text-foreground-950 mb-3">
          404
        </h1>
        <p className="text-foreground-600 text-base leading-relaxed mb-8">
          This page does not exist. The page you are looking for might have been moved or deleted.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary-500 text-white text-sm font-medium px-6 py-3 rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line text-sm"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}